
import { Component, Vue } from 'vue-property-decorator'
import { mapActions, mapState } from 'vuex'
import keyCodeMapperCharacter from '@/utils/keycodemap.utils'
import * as onScan from 'onscan.js'
import ProductProvider from '@/resources/product.provider'
import StockMappingProvider from '@/resources/stock-mapping.provider'

@Component({
  components: {},
  computed: {
    ...mapState({
      products: (state: any) => state.StockMoveLocation.products,
      currentStep: (state: any) => state.StockMoveLocation.currentStep,
      origin: (state: any) => state.StockMoveLocation.origin,
      destination: (state: any) => state.StockMoveLocation.destination
    })
  },
  methods: {
    ...mapActions({
      addProduct: 'StockMoveLocation/addProduct',
      setProductQty: 'StockMoveLocation/setProductQty',
      bumpProduct: 'StockMoveLocation/bumpProduct',
      setMoveResults: 'StockMoveLocation/setMoveResults',
      removeProductByRowKey: 'StockMoveLocation/removeProductByRowKey',
      setCurrentStep: 'StockMoveLocation/setCurrentStep',
      setOrigin: 'StockMoveLocation/setOrigin',
      setDestination: 'StockMoveLocation/setDestination',
      setDefault: 'StockMoveLocation/setDefault',
      clearDestination: 'StockMoveLocation/clearDestination'
    })
  }
})
export default class StockMoveLocation extends Vue {
  productService = new ProductProvider()

  stockMappingService = new StockMappingProvider()

  products!: any

  currentStep!: any

  origin!: any

  destination!: any

  addProduct!: any

  setProductQty!: any

  bumpProduct!: any

  setMoveResults!: any

  removeProductByRowKey!: any

  setCurrentStep!: any

  setOrigin!: any

  setDestination!: any

  clearDestination!: any

  setDefault!: any

  loadingLocation = false

  loadingProduct = false

  loadingMove = false

  storeChoiceModal = false

  storeChoices: any[] = []

  get totalSkuAndTotalQty (): any {
    return {
      totalSku: this.products.length,
      totalQty: this.products.reduce((sum: number, item: any) => sum + item.qty, 0)
    }
  }

  mounted (): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    onScan.attachTo(document, {
      suffixKeyCodes: [13],
      reactToPaste: true,
      onScan (sCode) {
        if (_this.storeChoiceModal) {
          _this.$buefy.toast.open({ message: 'กรุณาเลือก Store ก่อน', type: 'is-warning' })
          return
        }
        const patternUrl = /^(https:\/\/www\.gentlewomanonline\.com\/|https:\/\/gentlewomanonline\.com\/|https:\/\/www\.matter-makers\.com\/|https:\/\/matter-makers\.com\/)/
        const patternOldLocation = /^location::/
        const scanned = sCode.trim()
        if (patternUrl.test(scanned.toLowerCase())) {
          const splitCodeFromUrl = scanned.split('/')
          const code = splitCodeFromUrl[splitCodeFromUrl.length - 1]
          if (code) _this.addToMoveList(code)
        } else if (patternOldLocation.test(scanned)) {
          _this.$buefy.toast.open({ message: 'QR Location แบบเก่าใช้กับ Stock Move Location ไม่ได้', type: 'is-danger' })
        } else if (scanned) {
          // QR ของ location คือชื่อ location
          _this.getLocation(scanned)
        } else {
          _this.$buefy.toast.open({ message: 'QR Code นี้ไม่สามารถใช้งานได้', type: 'is-danger' })
        }
      },
      keyCodeMapper (oEvent: any) {
        // onScan ตัด space ทิ้ง แต่ชื่อ location มีช่องว่างได้
        if (+oEvent.keyCode === 32) return ' '
        if (keyCodeMapperCharacter[+oEvent.keyCode] !== undefined) {
          return keyCodeMapperCharacter[+oEvent.keyCode][+oEvent.shiftKey]
        }
        return onScan.decodeKeyEvent(oEvent)
      }
    })
  }

  async getLocation (name: string): Promise<void> {
    if (this.currentStep === 'summary') {
      this.$buefy.toast.open({ message: 'หากต้องการเปลี่ยน Location กรุณากดกลับเพื่อดำเนินการต่อ', type: 'is-danger' })
      return
    }
    if (this.currentStep === 'scan_product' && this.products.length) {
      this.$buefy.toast.open({
        message: 'ไม่สามารถเปลี่ยน Location ต้นทางได้ขณะมีสินค้าอยู่ กรุณาลบสินค้า หรือ กดยกเลิกเพื่อเริ่มใหม่', type: 'is-danger'
      })
      return
    }
    try {
      this.loadingLocation = true
      const { data } = await this.stockMappingService.getLocationByName(name)
      if (!data) {
        this.$buefy.toast.open({ message: `ไม่พบ location: ${name}`, type: 'is-danger' })
      } else if (this.currentStep === 'scan_destination') {
        if (data.id !== this.origin.id) {
          this.setDestination(data)
        } else {
          this.$buefy.toast.open({ message: 'Location ปลายทางไม่สามารถซ้ำกับต้นทางได้', type: 'is-danger' })
        }
      } else {
        this.setOrigin(data)
        this.setCurrentStep('scan_product')
      }
    } catch (error: any) {
      const message = error?.code === 404
        ? `ไม่พบ location: ${name}`
        : 'เกิดข้อผิดพลาดในการดึงข้อมูล location'
      this.$buefy.toast.open({ message, type: 'is-danger' })
    } finally {
      this.loadingLocation = false
    }
  }

  async addToMoveList (code: string): Promise<void> {
    let errorMsg = ''
    if (this.currentStep === 'scan_origin' && !this.origin) {
      errorMsg = 'กรุณาสแกน QR Code ของ Location ต้นทาง'
    } else if (this.currentStep === 'scan_destination' || this.currentStep === 'summary') {
      errorMsg = 'หากต้องการแก้ไข หรือเพิ่ม สินค้า กรุณากดกลับไปยังหน้าสแกนสินค้า'
    }

    if (errorMsg) {
      this.$buefy.toast.open({ message: errorMsg, type: 'is-danger' })
      return
    }

    // สแกนซ้ำ: บวกเข้าแถวล่าสุดของ code นี้ ไม่ต้องเลือก store ใหม่
    const existing = this.products.find((p: any) => p.code === code)
    if (existing) {
      this.bumpProduct(existing.rowKey)
      return
    }

    const skus = await this.getProductInfo(code)
    if (skus.length === 1) {
      this.pushProduct(skus[0])
    } else if (skus.length > 1) {
      this.storeChoices = skus
      this.storeChoiceModal = true
    }
  }

  pushProduct (sku: any): void {
    const rowKey = `${sku.code}::${sku.store?.id}`
    if (this.products.some((p: any) => p.rowKey === rowKey)) {
      this.bumpProduct(rowKey)
    } else {
      this.addProduct({ ...sku, rowKey, qty: 1, timeStamp: Date.now() })
    }
  }

  selectStore (sku: any): void {
    this.storeChoiceModal = false
    this.storeChoices = []
    this.pushProduct(sku)
  }

  saveMove (): void {
    this.$buefy.dialog.alert({
      title: 'บันทึกการย้าย Location สินค้า',
      message: 'ต้องการบันทึกการย้าย Location สินค้าหรือไม่',
      confirmText: 'บันทึก',
      cancelText: 'ยกเลิก',
      canCancel: true,
      onConfirm: () => {
        this.moveLocation()
      },
      type: 'is-info',
      hasIcon: true
    })
  }

  async moveLocation (): Promise<void> {
    try {
      this.loadingMove = true
      const { data: results } = await this.stockMappingService.moveLocation({
        origin: this.origin.id,
        destination: this.destination.id,
        productSkus: this.products.map((p: any) => ({ code: p.code, qty: p.qty, storeId: p.store?.id }))
      })
      const totalItem = this.products.length
      await this.setMoveResults(results || [])
      const failedItem = this.products.length
      if (!failedItem) {
        this.$buefy.toast.open({ message: 'การย้าย location สินค้าสำเร็จ', type: 'is-success' })
        this.setDefault()
        return
      }
      // ย้ายได้บางรายการ: เหลือเฉพาะรายการที่ไม่สำเร็จให้แก้จำนวนแล้วส่งใหม่
      this.setCurrentStep('scan_product')
      this.$buefy.dialog.alert({
        title: 'ย้ายไม่สำเร็จบางรายการ',
        message: `ย้ายสำเร็จ ${totalItem - failedItem} รายการ<br>ไม่สำเร็จ ${failedItem} รายการ กรุณาตรวจสอบจำนวนแล้วบันทึกใหม่`,
        confirmText: 'ตกลง',
        type: 'is-warning',
        hasIcon: true
      })
    } catch (error: any) {
      const message = error?.code === 400 && typeof error.message === 'string'
        ? error.message
        : 'การย้าย location สินค้าผิดพลาด'
      this.$buefy.toast.open({ message, type: 'is-danger' })
    } finally {
      this.loadingMove = false
    }
  }

  incrementItem (product: any): void {
    this.setProductQty({ rowKey: product.rowKey, qty: product.qty + 1 })
  }

  decrementItem (product: any): void {
    if (product.qty === 1) {
      this.removeItem(product.rowKey)
    } else {
      this.setProductQty({ rowKey: product.rowKey, qty: product.qty - 1 })
    }
  }

  removeItem (rowKey: string): void {
    this.$buefy.dialog.confirm({
      message: 'ต้องการลบสินค้านี้หรือไม่',
      canCancel: true,
      confirmText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      type: 'is-danger',
      onConfirm: async () => {
        this.removeProductByRowKey(rowKey)
      }
    })
  }

  async getProductInfo (code: string): Promise<any[]> {
    // ค้นทุก store: code เดียวกันอาจได้กลับมาหลาย store
    try {
      this.loadingProduct = true
      const { data: productSku } = await this.productService.getProductByCodeAllStore({
        skuCodes: [code]
      })
      if (productSku?.length) {
        return productSku
      }
      this.$buefy.toast.open({ message: 'QR Code นี้ไม่สามารถใช้งานได้', type: 'is-danger' })
    } catch (error) {
      this.$buefy.toast.open({ message: 'เกิดข้อผิดพลาดในการดึงข้อมูลสินค้า', type: 'is-danger' })
    } finally {
      this.loadingProduct = false
    }
    return []
  }

  onCancel (): void {
    this.$buefy.dialog.confirm({
      message: 'ต้องการยกเลิกการย้าย Location สินค้าหรือไม่',
      canCancel: true,
      confirmText: 'ต้องการ',
      cancelText: 'ไม่ต้องการ',
      type: 'is-danger',
      onConfirm: async () => {
        this.setDefault()
      }
    })
  }

  // eslint-disable-next-line class-methods-use-this
  beforeDestroy (): void {
    onScan.detachFrom(document)
  }
}
